// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__23GJ8","tab":"ProcedureTabs_tab__1Yzyf"};